var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.language["common.action"],
        width: 800,
        ok: false,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okButtonProps: { props: { disabled: _vm.disableSubmit } },
        okText: this.$store.getters.language["common.okButton"],
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["depart.management.oldDepartName"],
                    prop: "departName",
                    hidden: false
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      id: "departName",
                      placeholder: "",
                      disabled: true
                    },
                    model: {
                      value: _vm.model.departName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "departName", $$v)
                      },
                      expression: "model.departName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["depart.management.transfer"],
                    hidden: false
                  }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      on: { change: _vm.transferChange },
                      model: {
                        value: _vm.isTransfer,
                        callback: function($$v) {
                          _vm.isTransfer = $$v
                        },
                        expression: "isTransfer"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: "2" } }, [
                        _vm._v(
                          _vm._s(_vm.language["depart.management.transfer.now"])
                        )
                      ]),
                      _c("a-radio", { attrs: { value: "1" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.language["depart.management.transfer.wait"]
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.showEffectiveDate
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["system.effectiveDate"]
                      }
                    },
                    [
                      _c("a-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseChoose"] +
                            _vm.language["system.effectiveDate"],
                          "disabled-date": _vm.disabledDate,
                          format: _vm.dateFormat,
                          getCalendarContainer: function(node) {
                            return node.parentNode
                          }
                        },
                        model: {
                          value: _vm.model.effectiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "effectiveDate", $$v)
                          },
                          expression: "model.effectiveDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "parentId",
                    label: _vm.language["depart.management.FDepart"]
                  }
                },
                [
                  _c("a-tree-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      dropdownStyle: { maxHeight: "200px", overflow: "auto" },
                      treeData: _vm.treeData,
                      placeholder: _vm.language["common.not"]
                    },
                    model: {
                      value: _vm.model.parentId,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "parentId", $$v)
                      },
                      expression: "model.parentId"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isPreviousOrNot,
                      expression: "isPreviousOrNot"
                    }
                  ]
                },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.departName"],
                        prop: "departNameNew",
                        hidden: false
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          id: "departNameNew",
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.departName"]
                        },
                        model: {
                          value: _vm.model.departNameNew,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "departNameNew", $$v)
                          },
                          expression: "model.departNameNew"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.orgCategory"]
                      }
                    },
                    [
                      _vm.seen
                        ? [
                            _c(
                              "a-radio-group",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseChoose"] +
                                    _vm.language[
                                      "depart.management.orgCategory"
                                    ]
                                },
                                model: {
                                  value: _vm.model.orgCategory,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "orgCategory", $$v)
                                  },
                                  expression: "model.orgCategory"
                                }
                              },
                              [
                                _c("a-radio", { attrs: { value: "1" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.language["common.company"]) +
                                      "\n                "
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "a-radio-group",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseChoose"] +
                                    _vm.language[
                                      "depart.management.orgCategory"
                                    ]
                                },
                                model: {
                                  value: _vm.model.orgCategory,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "orgCategory", $$v)
                                  },
                                  expression: "model.orgCategory"
                                }
                              },
                              [
                                _c("a-radio", { attrs: { value: "2" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.language["depart"]) +
                                      "\n                "
                                  )
                                ]),
                                _c("a-radio", { attrs: { value: "3" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.language["common.post"]) +
                                      "\n                "
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "mobile",
                        label: _vm.language["depart.management.mobile"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.mobile"]
                        },
                        model: {
                          value: _vm.model.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "mobile", $$v)
                          },
                          expression: "model.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.fax"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.fax"]
                        },
                        model: {
                          value: _vm.model.fax,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "fax", $$v)
                          },
                          expression: "model.fax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.address"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.address"]
                        },
                        model: {
                          value: _vm.model.address,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "address", $$v)
                          },
                          expression: "model.address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["common.sort"]
                      }
                    },
                    [
                      _c("a-input-number", {
                        model: {
                          value: _vm.model.departOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "departOrder", $$v)
                          },
                          expression: "model.departOrder"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.expenseCode"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.expenseCode"]
                        },
                        model: {
                          value: _vm.model.expenseCode,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "expenseCode", $$v)
                          },
                          expression: "model.expenseCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "levelNo",
                        label: _vm.language["depart.management.levelNo"]
                      }
                    },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseChoose"] +
                            _vm.language["depart.management.levelNo"],
                          allowClear: true,
                          dictCode: "depart_category"
                        },
                        model: {
                          value: _vm.model.levelNo,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "levelNo", $$v)
                          },
                          expression: "model.levelNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.deportDirector"]
                      }
                    },
                    [
                      _c("j-select-user", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseChoose"] +
                            _vm.language["depart.management.deportDirector"],
                          multiple: false
                        },
                        model: {
                          value: _vm.model.departChief,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "departChief", $$v)
                          },
                          expression: "model.departChief"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        prop: "artificialPerson",
                        label:
                          _vm.language["depart.management.artificialPerson"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            allowClear: "",
                            placeholder:
                              _vm.language["common.pleaseChoose"] +
                              _vm.language["depart.management.artificialPerson"]
                          },
                          model: {
                            value: _vm.model.artificialPerson,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "artificialPerson", $$v)
                            },
                            expression: "model.artificialPerson"
                          }
                        },
                        _vm._l(_vm.artificialPersonList, function(item, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index.toString(),
                              attrs: { value: item.id }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.legalpersonName) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        prop: "siteCode",
                        label: _vm.language["depart.management.siteCode"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            allowClear: "",
                            placeholder:
                              _vm.language["common.pleaseChoose"] +
                              _vm.language["depart.management.siteCode"]
                          },
                          model: {
                            value: _vm.model.siteCode,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "siteCode", $$v)
                            },
                            expression: "model.siteCode"
                          }
                        },
                        _vm._l(_vm.siteCodeList, function(item, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index.toString(),
                              attrs: { value: item.id }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.factoryName) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["depart.management.memo"]
                      }
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["depart.management.memo"]
                        },
                        model: {
                          value: _vm.model.memo,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "memo", $$v)
                          },
                          expression: "model.memo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }